<template>
  <v-card class="pa-md-5 mt-4" elevation="3">
    <v-img :src="picture" class="mr-2 badge" alt="rank"></v-img>

    <v-card-title>
      <v-flex xs2>
        <v-img :src="Sponsor.logo" :alt="Sponsor.name"></v-img>
      </v-flex>
      <v-flex v-if="Sponsor.showName" mx-5 display-1>{{ Sponsor.name }}</v-flex>
    </v-card-title>
    <v-card-text v-html="Sponsor.text"> </v-card-text>

    <v-card-actions
      v-if="Sponsor.enableOpportunities && Sponsor.opportunities.length > 0"
    >
      <v-spacer></v-spacer>
      <v-btn outlined @click="show = !show"
        >See available positions
        <v-icon>{{
          show ? "keyboard_arrow_up" : "keyboard_arrow_down"
        }}</v-icon>
      </v-btn>
    </v-card-actions>
    <v-card-actions v-if="!Sponsor.enableOpportunities && Sponsor.applyLink">
      <v-spacer></v-spacer>
      <v-btn outlined target="_blank" :href="Sponsor.applyLink">
        Apply Externally
      </v-btn>
    </v-card-actions>

    <v-expand-transition
      v-if="Sponsor.enableOpportunities && filteredOpportunities.length > 0"
    >
      <div v-show="show">
        <v-divider></v-divider>
        <v-layout wrap>
          <v-flex
            v-for="opportunity in filteredOpportunities"
            :key="opportunity.id"
            xs12
            pa-2
          >
            <Opportunity :opportunity="opportunity"> </Opportunity>
          </v-flex>
        </v-layout>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import Opportunity from "./Opportunity";

export default {
  fiery: true,
  props: ["Sponsor"],
  data: () => ({
    show: false
  }),
  components: { Opportunity },
  computed: {
    filteredOpportunities() {
      return this.Sponsor.opportunities.filter(
        o => !o.deleted || o.applications[0]
      );
    },
    picture() {
      if (this.Sponsor && this.Sponsor.bespoke) {
        if (this.Sponsor.rank === "Gold") {
          return require("@/assets/images/icons/gold_bespoke.png");
        } else if (this.Sponsor.rank === "Silver") {
          return require("@/assets/images/icons/silver_bespoke.png");
        } else if (this.Sponsor.rank === "Bronze") {
          return require("@/assets/images/icons/bronze_bespoke.png");
        } else {
          return "";
        }
      } else {
        return "";
      }
    }
  },
  methods: {}
};
</script>

<style scoped>
.badge {
  position: absolute;
  width: 40px;
  right: -20px;
  top: -10px;
}
</style>